import React from 'react';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';

export default function TabPanel({ children, value, index, componentName, ...other }) {
  // const { children, value, index, ...other } = props;
  
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`${componentName}-tabpanel-${index}`}
      aria-labelledby={`${componentName}-${index}`}
      {...other}
    >
      {value === index && 
          <Box height="100%" p={0}>
            {children}
          </Box>
      }
    </div>
  );
}
  
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};